import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

// Import context
import { WalletProvider } from './context/WalletContext';

// Import pages
import HomePage from './pages/HomePage';
import BlindboxPage from './pages/BlindboxPage';
import LiquidityPage from './pages/LiquidityPage';
import DashboardPage from './pages/DashboardPage';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <WalletProvider>
      <Box minH="100vh" display="flex" flexDirection="column">
        <Navbar />
        <Box flex="1" py={6}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blindbox" element={<BlindboxPage />} />
            <Route path="/liquidity" element={<LiquidityPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </WalletProvider>
  );
};

export default App;
